(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8175],{

/***/ 92994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ ActionModal_ActionModal; },
  "z": function() { return /* reexport */ ActionModal_ActionModalItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./koba/components/Modal/index.js + 1 modules
var Modal = __webpack_require__(97971);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./components/ActionModal/ActionModal.module.scss
var ActionModal_module = __webpack_require__(97346);
var ActionModal_module_default = /*#__PURE__*/__webpack_require__.n(ActionModal_module);
;// CONCATENATED MODULE: ./components/ActionModal/ActionModal.tsx







var cx = bind_default().bind((ActionModal_module_default()));
var ActionModal = function(param) {
    var _children = param.children, children = _children === void 0 ? null : _children, isOpen = param.isOpen, closeModal = param.closeModal, t = param.t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        closeModal: closeModal,
        isOpen: isOpen,
        isFullWidth: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: cx("action-modal__body"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cx("action-modal__list"),
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* ButtonWithIconOnly */.Au, {
                    appearance: "knockout",
                    "aria-label": t("Close modal"),
                    className: cx("action-modal__close-button"),
                    onClick: closeModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        name: "x-dismiss"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ActionModal_ActionModal = (ActionModal);

// EXTERNAL MODULE: ./components/ActionModal/ActionModalItem.module.scss
var ActionModalItem_module = __webpack_require__(11595);
var ActionModalItem_module_default = /*#__PURE__*/__webpack_require__.n(ActionModalItem_module);
;// CONCATENATED MODULE: ./components/ActionModal/ActionModalItem.tsx




var ActionModalItem_cx = bind_default().bind((ActionModalItem_module_default()));
var ActionModalItem = function(param) {
    var children = param.children, _isDanger = param.isDanger, isDanger = _isDanger === void 0 ? false : _isDanger, title = param.title, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: ActionModalItem_cx("action-modal-item", {
            "action-modal-item--danger": isDanger
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: ActionModalItem_cx("action-modal-item__button"),
            role: "button",
            tabIndex: 0,
            title: title,
            onClick: onClick,
            onKeyPress: onClick,
            children: children
        })
    });
};
/* harmony default export */ var ActionModal_ActionModalItem = (ActionModalItem);

;// CONCATENATED MODULE: ./components/ActionModal/index.ts





/***/ }),

/***/ 54812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ HighlightContainer_HighlightContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/linkifyjs/dist/linkify.module.js
var linkify_module = __webpack_require__(51854);
// EXTERNAL MODULE: ./node_modules/react-highlight-words/dist/main.js
var main = __webpack_require__(37763);
var main_default = /*#__PURE__*/__webpack_require__.n(main);
// EXTERNAL MODULE: ./utils/regex/index.ts
var regex = __webpack_require__(14255);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Tooltip-00b73669.js
var Tooltip_00b73669 = __webpack_require__(20021);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./constants/eventNames.ts
var eventNames = __webpack_require__(81340);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./components/UserAvatar/index.ts + 2 modules
var UserAvatar = __webpack_require__(82957);
// EXTERNAL MODULE: ./components/HighlightArea/Highlight/Highlight.module.scss
var Highlight_module = __webpack_require__(12114);
var Highlight_module_default = /*#__PURE__*/__webpack_require__.n(Highlight_module);
;// CONCATENATED MODULE: ./components/HighlightArea/Highlight/Highlight.tsx












var cx = bind_default().bind((Highlight_module_default()));
var Highlight = function(param) {
    var highlightMatch = param.highlightMatch, mentionClassName = param.className, emailAndLinkMap = param.emailAndLinkMap, userIdToAvatarMap = param.userIdToAvatarMap;
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), trackEvent = ref.trackEvent, currentUser = ref.currentUser;
    var t = (0,es/* useTranslation */.$G)().t;
    var userMentionRef = (0,react.useRef)(null);
    var isMention = highlightMatch.match(regex/* MENTION_REGEX */.xA);
    var isLink = !!emailAndLinkMap[highlightMatch];
    var name = isMention && "".concat(highlightMatch.substring(highlightMatch.indexOf("[") + 1, highlightMatch.lastIndexOf("]"))) || t("User not found");
    var userId = isMention && "".concat(highlightMatch.substring(highlightMatch.indexOf("(") + 1, highlightMatch.lastIndexOf(")"))) || "";
    var onKeyDown = function(event) {
        if (event.key === "Enter" || event.key === " ") {
            handleOpenUserProfilePanel(event);
        }
    };
    var avatarUrl = userIdToAvatarMap === null || userIdToAvatarMap === void 0 ? void 0 : userIdToAvatarMap[userId];
    var handleOpenUserProfilePanel = function(event) {
        event.preventDefault();
        event.stopPropagation();
        PubSub.publish(eventNames/* eventNames.OPEN_PROFILE_PANEL */.S.OPEN_PROFILE_PANEL, {
            userId: userId,
            lastElementRef: userMentionRef
        });
        trackEvent(trackingEvents/* default.PROFILE_PANEL_TAB_OPENED */.ZP.PROFILE_PANEL_TAB_OPENED, (0,_define_property/* default */.Z)({}, trackingEvents/* TrackingProperty.WAS_OPENED_FROM_MENTION */.Ku.WAS_OPENED_FROM_MENTION, true));
    };
    if (isMention) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_00b73669.T, {
            className: cx("mention__tooltip"),
            displayElements: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* default */.Z, {
                avatarUrl: avatarUrl,
                className: cx("user__avatar"),
                size: "xs",
                srcSet: "".concat(avatarUrl, "?width=40 1x, ").concat(avatarUrl, "?width=40&dpr=2 2x, ").concat(avatarUrl, "?width=40&dpr=3 3x"),
                userId: userId || "",
                username: name
            }),
            displayElementsClassName: cx("mention__tooltip-display"),
            innerClassName: cx("mention__tooltip-inner"),
            placement: "top",
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                },
                children: name
            }),
            isDark: true,
            isOpaque: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                "aria-hidden": false,
                "aria-label": name,
                className: cx(mentionClassName.trim(), {
                    "current-user": currentUser.id === userId
                }),
                "data-qa": "mentions__highlight",
                ref: userMentionRef,
                role: "button",
                tabIndex: 0,
                onClick: handleOpenUserProfilePanel,
                onKeyDown: onKeyDown,
                children: [
                    "@",
                    name
                ]
            })
        }, name);
    }
    if (isLink) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "data-qa": "link__highlight",
            href: emailAndLinkMap[highlightMatch],
            target: "_blank",
            onClick: function(event) {
                return event.stopPropagation();
            },
            children: highlightMatch
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: cx("highlight"),
        children: highlightMatch
    });
};
/* harmony default export */ var Highlight_Highlight = (Highlight);

;// CONCATENATED MODULE: ./components/HighlightArea/HighlightContainer/HighlightContainer.tsx








var HighlightContainer = function(param) {
    var content = param.content, mentionedUsers = param.mentionedUsers;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var query = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.q;
    var emailAndLinkValues = [];
    var emailAndLinkMap = {};
    var userIdToAvatarMap = {};
    var arrayOfEmailsAndLinks = linkify_module/* find */.sE(content);
    emailAndLinkValues = arrayOfEmailsAndLinks.filter(function(node) {
        var isValid = true;
        try {
            /* eslint-disable no-debugger, no-new */ new RegExp(node.value);
        } catch (e) {
            isValid = false;
        }
        return isValid;
    }).map(function(node) {
        emailAndLinkMap[node.value] = node.href;
        return (0,regex/* escapeRegex */.yI)(node.value);
    });
    mentionedUsers === null || mentionedUsers === void 0 ? void 0 : (ref1 = mentionedUsers.edges) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(mentionedUser) {
        var ref;
        var id = mentionedUser === null || mentionedUser === void 0 ? void 0 : (ref = mentionedUser.node) === null || ref === void 0 ? void 0 : ref.id;
        if (id) {
            var ref1;
            userIdToAvatarMap[id] = (mentionedUser === null || mentionedUser === void 0 ? void 0 : (ref1 = mentionedUser.node) === null || ref1 === void 0 ? void 0 : ref1.avatarUrl) || "";
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((main_default()), {
        highlightClassName: "mentions-highlight",
        highlightTag: function(results) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight_Highlight, {
                className: results.className,
                emailAndLinkMap: emailAndLinkMap,
                highlightMatch: results.children,
                userIdToAvatarMap: userIdToAvatarMap
            });
        },
        searchWords: (0,_to_consumable_array/* default */.Z)(emailAndLinkValues).concat([
            regex/* MENTION_REGEX */.xA,
            query
        ]),
        textToHighlight: content,
        caseSensitive: true
    });
};
/* harmony default export */ var HighlightContainer_HighlightContainer = (HighlightContainer);

;// CONCATENATED MODULE: ./components/HighlightArea/HighlightContainer/index.ts



/***/ }),

/***/ 43485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_HighlightArea_HighlightContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54812);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75826);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79707);
/* harmony import */ var _Post_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82845);
/* harmony import */ var _Post_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Post_module_scss__WEBPACK_IMPORTED_MODULE_5__);







var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_3___default().bind((_Post_module_scss__WEBPACK_IMPORTED_MODULE_5___default()));
var AttachmentDisplayer;
var PostContent = function(param) {
    var shouldClampContent = param.shouldClampContent, postToScrollToOffset = param.postToScrollToOffset, setShouldClampContent = param.setShouldClampContent, content = param.content, hasAttachment = param.hasAttachment, firstAttachment = param.firstAttachment, mentionedUsers = param.mentionedUsers, isPostPage = param.isPostPage, shouldScroll = param.shouldScroll, t = param.t;
    // Component Loading
    if (!AttachmentDisplayer) {
        AttachmentDisplayer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
            return Promise.all(/* import() */[__webpack_require__.e(1178), __webpack_require__.e(7164)]).then(__webpack_require__.bind(__webpack_require__, 57164));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(57164)
                    ];
                }
            },
            loading: function() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_6__.L, {
                    accessibilityLabel: t("common-loading", "Loading")
                });
            }
        });
    }
    var handleExpandCollapse = function(e) {
        if (!shouldClampContent && shouldScroll) {
            window.scrollTo(0, postToScrollToOffset || 0);
        }
        e.preventDefault();
        e.stopPropagation();
        setShouldClampContent(!shouldClampContent);
    };
    var readContentButton = content.length > 480 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_7__.B, {
        appearance: "accessible-link",
        className: cx("post__content--button"),
        "data-qa": "read-post__button",
        onClick: handleExpandCollapse,
        children: shouldClampContent ? t("Read more") : t("Read less")
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: cx("post__content", hasAttachment ? "post__content--attachment" : ""),
        "data-qa": "post__content",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: cx("post__content__text", shouldClampContent ? "post__content__text--clamped" : ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_HighlightArea_HighlightContainer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    content: content,
                    mentionedUsers: mentionedUsers
                })
            }),
            readContentButton,
            hasAttachment && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AttachmentDisplayer, {
                attachment: firstAttachment,
                isPostPage: isPostPage,
                t: t
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostContent);


/***/ }),

/***/ 74883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67421);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var koba_components_Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63579);
/* harmony import */ var koba_components_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8236);
/* harmony import */ var components_PostActions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29035);
/* harmony import */ var components_UserDetail__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50826);
/* harmony import */ var _Post_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82845);
/* harmony import */ var _Post_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_Post_module_scss__WEBPACK_IMPORTED_MODULE_8__);









var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_3___default().bind((_Post_module_scss__WEBPACK_IMPORTED_MODULE_8___default()));
var PostHeader = function(param) {
    var isFollowing = param.isFollowing, author = param.author, editedAt = param.editedAt, creationDateTime = param.creationDateTime, pinnedAt = param.pinnedAt, showFollowingTag = param.showFollowingTag, postActionsList = param.postActionsList, isMobile = param.isMobile, title = param.title;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: cx("post__detail-header", {
                    "is-following": showFollowingTag && isFollowing
                }),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_UserDetail__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        author: author,
                        editedAt: editedAt,
                        time: creationDateTime || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: cx("post__detail-actions"),
                        children: [
                            showFollowingTag && isFollowing && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(koba_components_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Caption */ .Y, {
                                className: cx("post__detail-actions__follow-tag"),
                                children: t("Following")
                            }),
                            pinnedAt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(koba_components_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                ariaLabel: t("This post is pinned to the top of the list"),
                                className: cx("post__detail-actions__pin-icon"),
                                name: "pin"
                            }),
                            postActionsList.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_PostActions__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                actionsList: postActionsList,
                                isMobile: isMobile,
                                t: t
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(koba_components_Typography__WEBPACK_IMPORTED_MODULE_4__.H1, {
                className: cx("post__title"),
                "data-qa": "main-post-title__text",
                children: title
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostHeader);


/***/ }),

/***/ 87037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67421);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var koba_components_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8236);
/* harmony import */ var constants_trackingEvents__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89131);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_CommunityContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9973);
/* harmony import */ var utils_routerHelpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4154);
/* harmony import */ var helpers_spaceHelpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68556);
/* harmony import */ var utils_rawId__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93593);
/* harmony import */ var _PostSpaceBadge_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56571);
/* harmony import */ var _PostSpaceBadge_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_PostSpaceBadge_module_scss__WEBPACK_IMPORTED_MODULE_10__);













var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_3___default().bind((_PostSpaceBadge_module_scss__WEBPACK_IMPORTED_MODULE_10___default()));
var PostSpaceBadge = function(param) {
    var communityId = param.communityId, spaceId = param.spaceId, spaceName = param.spaceName, spaceIconName = param.spaceIconName;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref = (0,components_CommunityContext__WEBPACK_IMPORTED_MODULE_7__/* .useCommunityContext */ .v1)(), community = ref.community, trackEvent = ref.trackEvent;
    var handleClickOnSpaceBadge = function(event, filter, name) {
        event.preventDefault();
        event.stopPropagation();
        var _obj;
        trackEvent(constants_trackingEvents__WEBPACK_IMPORTED_MODULE_5__/* ["default"].SPACE_CLICKED */ .ZP.SPACE_CLICKED, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_5__/* .TrackingProperty.SPACE_ID */ .Ku.SPACE_ID, (0,utils_rawId__WEBPACK_IMPORTED_MODULE_12__/* .rawId */ .b)(filter)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_5__/* .TrackingProperty.SPACE_NAME */ .Ku.SPACE_NAME, name), _obj));
        (0,utils_routerHelpers__WEBPACK_IMPORTED_MODULE_8__/* .goToSpaces */ .ZY)(router, filter, community.id, true);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
        "aria-label": t("Go to {{space}}", {
            space: spaceName
        }),
        className: cx("badge"),
        "data-qa": "space-badge-link",
        href: "/communities/".concat(communityId, "/spaces/").concat(spaceId),
        title: spaceName || "",
        onClick: function(event) {
            return handleClickOnSpaceBadge(event, spaceId, spaceName);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(koba_components_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                className: cx("badge__icon"),
                "data-qa": "post__space__icon",
                name: (0,helpers_spaceHelpers__WEBPACK_IMPORTED_MODULE_9__/* .getIconNameByStoredValue */ .i)(spaceIconName || "")
            }),
            spaceName
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostSpaceBadge);


/***/ }),

/***/ 29035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PostActions_PostActions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./koba/components/Dropdown/constants.ts
var constants = __webpack_require__(43989);
// EXTERNAL MODULE: ./koba/components/InlineActions/constants.js
var InlineActions_constants = __webpack_require__(98939);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./koba/components/Dropdown/index.ts + 9 modules
var Dropdown = __webpack_require__(46744);
// EXTERNAL MODULE: ./koba/components/InlineActions/InlineActions.module.scss
var InlineActions_module = __webpack_require__(4861);
var InlineActions_module_default = /*#__PURE__*/__webpack_require__.n(InlineActions_module);
;// CONCATENATED MODULE: ./koba/components/InlineActions/InlineActions.js
















var cx = bind_default().bind((InlineActions_module_default()));
var InlineActions = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(InlineActions, Component);
    var _super = (0,_create_super/* default */.Z)(InlineActions);
    function InlineActions(props) {
        (0,_class_call_check/* default */.Z)(this, InlineActions);
        var _this;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onHoverHandler", function(hasFocus) {
            return function(e) {
                e.stopPropagation();
                _this.setState({
                    hasFocus: hasFocus
                });
            };
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onMenuItemClick", function(onClickHandler) {
            return function(e) {
                e.stopPropagation();
                _this.setState({
                    isOpen: false
                });
                onClickHandler();
            };
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onToggleHandler", function(open) {
            _this.setState({
                isOpen: open
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "getMainAction", function() {
            var actions = _this.props.actions;
            return actions.filter(function(action) {
                return action.asButton;
            });
        });
        _this.onHoverHandler = _this.onHoverHandler.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onMenuItemClick = _this.onMenuItemClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onToggleHandler = _this.onToggleHandler.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.state = {
            hasFocus: props.hasFocus,
            isOpen: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(InlineActions, [
        {
            // eslint-disable-next-line camelcase
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                var hasFocus = nextProps.hasFocus;
                this.setState({
                    hasFocus: hasFocus
                });
            }
        },
        {
            key: "renderActions",
            value: function renderActions() {
                var _this = this;
                var _props = this.props, buttonAppearance = _props.buttonAppearance, forceMainActionOpen = _props.forceMainActionOpen, ariaLabel = _props.ariaLabel;
                var _state = this.state, hasFocus = _state.hasFocus, isOpen = _state.isOpen;
                var actionClasses = cx("action-button", {
                    active: forceMainActionOpen || hasFocus || isOpen
                });
                return this.getMainAction().map(function(action) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                        appearance: buttonAppearance,
                        ariaLabel: ariaLabel,
                        className: actionClasses,
                        onBlur: _this.onHoverHandler(false),
                        onClick: action.onClick,
                        onFocus: _this.onHoverHandler(true),
                        onMouseOut: _this.onHoverHandler(false),
                        onMouseOver: _this.onHoverHandler(true),
                        children: action.name
                    }, action.name);
                });
            }
        },
        {
            key: "renderMoreActions",
            value: function renderMoreActions() {
                var _this = this;
                var _props = this.props, ariaLabel = _props.ariaLabel, buttonAppearance = _props.buttonAppearance, icon = _props.icon, actions = _props.actions, alignment = _props.alignment, forceMainActionOpen = _props.forceMainActionOpen, isCompactMode = _props.isCompactMode, dimensions = _props.dimensions;
                var _state = this.state, hasFocus = _state.hasFocus, isOpen = _state.isOpen;
                var isActionActive = forceMainActionOpen || hasFocus || isOpen;
                var deleteActions = actions.filter(function(action) {
                    return action.type === InlineActions_constants/* DANGER_TYPE */.Z;
                });
                var nonSpecializedActions = actions.filter(function(action) {
                    return !action.asButton && action.type !== InlineActions_constants/* DANGER_TYPE */.Z;
                });
                var hasMainAction = this.getMainAction().length > 0;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cx("ellipsis-button"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Dropdown */.Lt, {
                        toggleListener: this.onToggleHandler,
                        children: function(param) {
                            var open = param.open, toggleMenu = param.toggleMenu;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                        appearance: buttonAppearance,
                                        ariaLabel: ariaLabel,
                                        className: cx("inline-actions--toggle", {
                                            "inline-actions--active-toggle": isActionActive,
                                            "button--default": isActionActive,
                                            "compact-mode": isCompactMode,
                                            "has-main-action": !isCompactMode && hasMainAction
                                        }),
                                        dataQA: "inline-actions__btn",
                                        onClick: toggleMenu,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            name: icon
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* Menu */.v2, {
                                        dimensions: dimensions,
                                        open: open,
                                        position: alignment,
                                        children: [
                                            isCompactMode && _this.getMainAction().map(function(action) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Item */.ck, {
                                                    title: action.title || action.text,
                                                    onClick: _this.onMenuItemClick(action.onClick),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                                        appearance: "knockout",
                                                        className: cx("inline-actions__more-actions--button"),
                                                        children: action.text
                                                    })
                                                }, action.name);
                                            }),
                                            nonSpecializedActions.map(function(action) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Item */.ck, {
                                                    className: cx("inline-actions__item"),
                                                    title: action.title || action.text,
                                                    onClick: _this.onMenuItemClick(action.onClick),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                                        appearance: "knockout",
                                                        className: cx("inline-actions__more-actions--button"),
                                                        children: action.text
                                                    })
                                                }, action.name);
                                            }),
                                            deleteActions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    nonSpecializedActions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                        className: cx("inline-actions__separator")
                                                    }),
                                                    deleteActions.map(function(deleteAction) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Item */.ck, {
                                                            className: cx("inline-actions__item", "dropdown"),
                                                            title: deleteAction.title || deleteAction.text,
                                                            onClick: deleteAction.onClick,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                                                appearance: "knockout",
                                                                className: cx("inline-actions__more-actions--button", "inline-actions__item--danger"),
                                                                hasDanger: true,
                                                                children: deleteAction.text
                                                            })
                                                        }, deleteAction.name);
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            });
                        }
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, alignment = _props.alignment, isCompactMode = _props.isCompactMode, wrapperClass = _props.wrapperClass;
                var containerClasses = cx("container", "container-".concat(alignment), wrapperClass);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: containerClasses,
                    children: [
                        alignment === "right" && !isCompactMode && this.renderActions(),
                        this.renderMoreActions(),
                        alignment === "left" && !isCompactMode && this.renderActions()
                    ]
                });
            }
        }
    ]);
    return InlineActions;
}(react.Component);
InlineActions.propTypes = {
    /** Array of the possible actions */ actions: prop_types_default().arrayOf(prop_types_default().shape({
        /** Flag to show as button instead of within toggle menu */ asButton: (prop_types_default()).bool,
        /** Name of action (appears as button text) */ name: (prop_types_default()).string.isRequired,
        /** More detailed text to display for action (appears in action menu) */ text: prop_types_default().oneOfType([
            (prop_types_default()).string,
            (prop_types_default()).node
        ]).isRequired,
        /** Title to be displayed on action hover. Should be passed when text property is a node. */ title: (prop_types_default()).string,
        /** Handler when action is clicked */ onClick: (prop_types_default()).func.isRequired
    })).isRequired,
    /** Alignment of the menu and buttons with the toggle */ alignment: prop_types_default().oneOf([
        "left",
        "right"
    ]),
    /** Button aria-label */ ariaLabel: (prop_types_default()).string,
    /** Button appearance */ buttonAppearance: prop_types_default().oneOf([
        "default",
        "knockout",
        "ghost"
    ]),
    dimensions: constants/* DROPDOWN_DIMENSIONS_PROP_TYPE */.Nh,
    /** For the main action to be shown * */ forceMainActionOpen: (prop_types_default()).bool,
    /** Flag to indicate component is in focus */ hasFocus: (prop_types_default()).bool,
    /** Icon for menu toggle */ icon: (prop_types_default()).string,
    /** Toggles the compact version * */ isCompactMode: (prop_types_default()).bool,
    /** Add classes to the wrapper container * */ wrapperClass: (prop_types_default()).string
};
InlineActions.defaultProps = {
    ariaLabel: null,
    buttonAppearance: "default",
    hasFocus: false,
    icon: "ellipsis-v",
    alignment: "right",
    forceMainActionOpen: false,
    isCompactMode: false,
    wrapperClass: null,
    dimensions: constants/* DROPDOWN_DIMENSIONS_DEFAULT_PROP */.yW
};
/* harmony default export */ var InlineActions_InlineActions = (InlineActions);

;// CONCATENATED MODULE: ./koba/components/InlineActions/index.js



// EXTERNAL MODULE: ./components/ActionModal/index.ts + 2 modules
var ActionModal = __webpack_require__(92994);
// EXTERNAL MODULE: ./components/PostActions/PostActions.module.scss
var PostActions_module = __webpack_require__(70589);
var PostActions_module_default = /*#__PURE__*/__webpack_require__.n(PostActions_module);
;// CONCATENATED MODULE: ./components/PostActions/PostActions.tsx










var PostActions_cx = bind_default().bind((PostActions_module_default()));
var PostActions = function(param) {
    var _actionsList = param.actionsList, actionsList = _actionsList === void 0 ? [] : _actionsList, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, t = param.t;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var openActionsModal = function(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setIsOpen(true);
    };
    var closeActionsModal = function(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setIsOpen(false);
    };
    var handleAction = function(action) {
        return function(e) {
            setIsOpen(false);
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            action();
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* ButtonWithIconOnly */.Au, {
                    appearance: "knockout",
                    ariaLabel: t("Open/close actions menu"),
                    className: PostActions_cx("post-actions__button"),
                    onClick: openActionsModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        className: PostActions_cx("post-actions__button-icon"),
                        name: "ellipsis-v"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionModal/* ActionModal */.W, {
                    closeModal: closeActionsModal,
                    isOpen: isOpen,
                    t: t,
                    children: actionsList.map(function(action) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionModal/* ActionModalItem */.z, {
                            isDanger: action.type === InlineActions_constants/* DANGER_TYPE */.Z,
                            title: action.title || action.text,
                            onClick: handleAction(action.onClick),
                            children: action.text
                        }, action.name);
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineActions_InlineActions, {
            actions: actionsList,
            ariaLabel: t("Open/close actions menu"),
            buttonAppearance: "knockout",
            wrapperClass: PostActions_cx("comment__inline-actions")
        })
    });
};
PostActions.propTypes = {
    actionsList: (prop_types_default()).array,
    isMobile: (prop_types_default()).bool,
    t: (prop_types_default()).func.isRequired
};
PostActions.defaultProps = {
    actionsList: [],
    isMobile: false
};
/* harmony default export */ var PostActions_PostActions = (PostActions);

;// CONCATENATED MODULE: ./components/PostActions/index.ts



/***/ }),

/***/ 50826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UserDetail_UserDetail; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Typography/index.ts + 6 modules
var Typography = __webpack_require__(63579);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/pubsub-js/src/pubsub.js
var pubsub = __webpack_require__(1798);
var pubsub_default = /*#__PURE__*/__webpack_require__.n(pubsub);
// EXTERNAL MODULE: ./components/UserAvatar/index.ts + 2 modules
var UserAvatar = __webpack_require__(82957);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./components/ModeratorBadge/index.ts + 1 modules
var ModeratorBadge = __webpack_require__(45475);
// EXTERNAL MODULE: ./constants/eventNames.ts
var eventNames = __webpack_require__(81340);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./components/UserDetail/UserDetail.module.scss
var UserDetail_module = __webpack_require__(88968);
var UserDetail_module_default = /*#__PURE__*/__webpack_require__.n(UserDetail_module);
;// CONCATENATED MODULE: ./components/UserDetail/UserDetail.tsx















var cx = bind_default().bind((UserDetail_module_default()));
var UserDetail = function(param) {
    var author = param.author, editedAt = param.editedAt, time = param.time, isEditing = param.isEditing, isReply = param.isReply, _totalReplyCount = param.totalReplyCount, totalReplyCount = _totalReplyCount === void 0 ? 0 : _totalReplyCount, isFollowing = param.isFollowing;
    if (!author) return null;
    var userDetailRef = (0,react.useRef)(null);
    var t = (0,es/* useTranslation */.$G)().t;
    var trackEvent = (0,CommunityContext/* useCommunityContext */.v1)().trackEvent;
    var userHasModeratorBadge = (0,userHelpers/* hasModeratorBadge */.x)(author);
    var profileAriaLabel = t("components-userDetail-posted_by_aria_label", "Posted by {{fullName}} {{moderator}} {{time}}. Press enter or space to open profile panel", {
        fullName: author.fullName,
        time: time,
        moderator: userHasModeratorBadge ? t("Moderator") : ""
    });
    var handleUserDetailAction = function(event) {
        if (event.key === "Enter" || event.key === " " || event.type === "click") {
            event.preventDefault();
            event.stopPropagation();
            pubsub_default().publish(eventNames/* eventNames.OPEN_PROFILE_PANEL */.S.OPEN_PROFILE_PANEL, {
                userId: author.id,
                lastElementRef: userDetailRef
            });
            trackEvent(trackingEvents/* default.PROFILE_PANEL_TAB_OPENED */.ZP.PROFILE_PANEL_TAB_OPENED, {});
        }
    };
    var extraProps = {
        role: "button",
        "aria-label": profileAriaLabel,
        tabIndex: 0,
        onClick: handleUserDetailAction,
        onKeyDown: handleUserDetailAction,
        ref: userDetailRef
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: cx("user-detail", {
            "user-detail__edit": isEditing,
            "user-detail__reply": isReply
        }),
        "data-qa": "user-detail"
    }, extraProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: cx("user-detail__wrapper"),
                "data-qa": "user-detail__wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* default */.Z, {
                    avatarUrl: author.avatarUrl,
                    className: cx("user-detail__avatar"),
                    size: "sm",
                    srcSet: "".concat(author.avatarUrl, "?width=40 1x, ").concat(author.avatarUrl, "?width=40&dpr=2 2x, ").concat(author.avatarUrl, "?width=40&dpr=3 3x"),
                    userId: author.id,
                    username: author.fullName || ""
                })
            }),
            !isEditing && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: cx("user-detail__name-moderator"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.P, {
                                className: cx("user-detail__name"),
                                "data-qa": "main-user-detail-name__link",
                                title: author.fullName || "",
                                children: author.fullName
                            }),
                            userHasModeratorBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeratorBadge/* default */.Z, {
                                className: cx("user-detail__moderator-badge"),
                                children: t("common-Moderator", "Moderator")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography.P, {
                        className: cx("user-detail__label"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: cx("user-detail__time"),
                                children: time
                            }),
                            editedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: cx("user-detail__edited"),
                                children: t("Edited")
                            }),
                            totalReplyCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: cx("user-detail__total-replies"),
                                children: t("{{count}} reply", {
                                    count: totalReplyCount
                                })
                            }),
                            !isReply && isFollowing && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: cx("user-detail__following"),
                                children: t("Following")
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var UserDetail_UserDetail = (UserDetail);

;// CONCATENATED MODULE: ./components/UserDetail/index.ts



/***/ }),

/***/ 98939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DANGER_TYPE; }
/* harmony export */ });
// eslint-disable-next-line import/prefer-default-export
var DANGER_TYPE = "danger";


/***/ }),

/***/ 94000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35330);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3__);








var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default()));
var ModalBody = function(_param) /*#__PURE__*/ {
    var children = _param.children, isFullWidth = _param.isFullWidth, hasTitle = _param.hasTitle, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "isFullWidth",
        "hasTitle"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: cx("modal__body", {
            "no-padding": isFullWidth,
            "no-title": !hasTitle
        })
    }, rest), {
        children: children
    }));
};
ModalBody.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node.isRequired),
    hasTitle: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    isFullWidth: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool)
};
ModalBody.defaultProps = {
    isFullWidth: false,
    hasTitle: false
};
ModalBody.displayName = "ModalBody";
/* harmony default export */ __webpack_exports__["Z"] = (ModalBody);


/***/ }),

/***/ 21838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35330);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3__);








var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default()));
var ModalFooter = function(_param) /*#__PURE__*/ {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: cx("modal__footer")
    }, rest), {
        children: children
    }));
};
ModalFooter.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node.isRequired)
};
ModalFooter.displayName = "ModalFooter";
/* harmony default export */ __webpack_exports__["Z"] = (ModalFooter);


/***/ }),

/***/ 70394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35330);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3__);








var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default()));
var ModalHeader = function(_param) /*#__PURE__*/ {
    var children = _param.children, className = _param.className, hasTitle = _param.hasTitle, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "hasTitle"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: cx("modal__header", className)
    }, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: cx({
                "has-title": hasTitle
            }),
            children: children
        })
    }));
};
ModalHeader.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node.isRequired),
    className: prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().array),
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object), 
    ]),
    hasTitle: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool)
};
ModalHeader.defaultProps = {
    className: null,
    hasTitle: false
};
ModalHeader.displayName = "ModalHeader";
/* harmony default export */ __webpack_exports__["Z"] = (ModalHeader);


/***/ }),

/***/ 97971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Modal_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./koba/components/Typography/index.ts + 6 modules
var Typography = __webpack_require__(63579);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./koba/components/Modal/ModalBody/ModalBody.js
var ModalBody = __webpack_require__(94000);
// EXTERNAL MODULE: ./koba/components/Modal/ModalFooter/ModalFooter.js
var ModalFooter = __webpack_require__(21838);
// EXTERNAL MODULE: ./koba/components/Modal/ModalHeader/ModalHeader.js
var ModalHeader = __webpack_require__(70394);
// EXTERNAL MODULE: ./koba/components/Modal/Modal.module.scss
var Modal_module = __webpack_require__(35330);
var Modal_module_default = /*#__PURE__*/__webpack_require__.n(Modal_module);
;// CONCATENATED MODULE: ./koba/components/Modal/Modal.js












var cx = bind_default().bind((Modal_module_default()));
var findComponent = function(children, componentToFind) {
    return react.Children.toArray(children).find(function(component) {
        return component.type && component.type.displayName === componentToFind;
    });
};
var Modal = function(param) {
    var modalBodyClasses = param.modalBodyClasses, children = param.children, contentLabel = param.contentLabel, closeModal = param.closeModal, isOpen = param.isOpen, title = param.title, footer = param.footer, isFullWidth = param.isFullWidth, dataQA = param.dataQA;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
        ariaHideApp: false,
        className: cx("modal", modalBodyClasses),
        contentLabel: contentLabel,
        data: {
            qa: dataQA
        },
        isOpen: isOpen,
        overlayClassName: cx("overlay"),
        onRequestClose: closeModal,
        children: [
            findComponent(children, "ModalHeader"),
            title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalHeader/* default */.Z, {
                hasTitle: !!title,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.H1, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                        appearance: "knockout",
                        "aria-label": "Close modal",
                        className: cx("modal__header__close-button"),
                        onClick: closeModal,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            name: "x-dismiss"
                        })
                    })
                ]
            }),
            findComponent(children, "ModalBody") || /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBody/* default */.Z, {
                hasTitle: !!title,
                isFullWidth: isFullWidth,
                children: children
            }),
            findComponent(children, "ModalFooter"),
            footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalFooter/* default */.Z, {
                children: footer
            })
        ]
    });
};
Modal.propTypes = {
    children: (prop_types_default()).node.isRequired,
    closeModal: (prop_types_default()).func.isRequired,
    contentLabel: (prop_types_default()).string,
    dataQA: (prop_types_default()).string,
    footer: (prop_types_default()).node,
    isFullWidth: (prop_types_default()).bool,
    isOpen: (prop_types_default()).bool.isRequired,
    modalBodyClasses: prop_types_default().oneOfType([
        (prop_types_default()).array,
        (prop_types_default()).string,
        (prop_types_default()).object, 
    ]),
    title: (prop_types_default()).node
};
Modal.defaultProps = {
    dataQA: null,
    modalBodyClasses: null,
    title: null,
    contentLabel: "Modal",
    footer: null,
    isFullWidth: false
};
/* harmony default export */ var Modal_Modal = (Modal);

;// CONCATENATED MODULE: ./koba/components/Modal/index.js



/***/ }),

/***/ 29296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q0": function() { return /* binding */ insertEmoji; },
/* harmony export */   "d1": function() { return /* binding */ makeMentionsUserFriendly; },
/* harmony export */   "gI": function() { return /* binding */ displayTransform; },
/* harmony export */   "gj": function() { return /* binding */ markupPattern; },
/* harmony export */   "yq": function() { return /* binding */ replaceMentions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var _regex__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14255);
/* harmony import */ var _textHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51661);



var markupPattern = "@[__display__](__id__)";
var displayTransform = function(_id, display) {
    return "@".concat(display);
};
/*
  Update user names in a block of text with their current name
 */ var replaceMentions = function(text, mentionedUsers) {
    var ref;
    var result = text || "";
    mentionedUsers === null || mentionedUsers === void 0 ? void 0 : (ref = mentionedUsers.edges) === null || ref === void 0 ? void 0 : ref.forEach(function(edge) {
        var node = edge === null || edge === void 0 ? void 0 : edge.node;
        if ((node === null || node === void 0 ? void 0 : node.id) && (node === null || node === void 0 ? void 0 : node.fullName)) {
            result = result.replace((0,_regex__WEBPACK_IMPORTED_MODULE_0__/* .mentionIdRegex */ .YA)(node.id), function() {
                return "@[".concat(node.fullName, "](").concat(node.id, ")");
            });
        }
    });
    return result;
};
var makeMentionsUserFriendly = function(text) {
    var result = text || "";
    if (result) {
        result = result.replace(_regex__WEBPACK_IMPORTED_MODULE_0__/* .MENTION_REGEX_GLOBAL */ .Vo, "@$1");
    }
    return result;
};
/*
  A super maintainable function that can insert emojis into react-mentions text. My sincerest apologies to the
  next person that needs to make a change to this.
  It requires that markupPattern equal @[__display__](__id__) and displayTransform returns @${display}
 */ var insertEmoji = function(emoji, position, value, content) {
    if (!emoji) return content || "";
    if (position === null || position > (value === null || value === void 0 ? void 0 : value.length)) return content;
    var currentContent = content;
    var isRestrictedPosition = false;
    var shiftRight = 0;
    var restrictedRanges = [];
    if (value !== content) {
        // If the textarea and the react-mentions content are different, it means mentions have been added
        for(var i = 0; i < position; i += 1){
            var currentChar = value[i];
            var currentContentChar = currentContent[i + shiftRight];
            var nextContentChar = currentContent[i + shiftRight + 1];
            if (currentChar === "@" && currentContentChar === "@" && nextContentChar === "[") {
                var indexOfNextClosingBracket = currentContent.indexOf("]", shiftRight + i + 2);
                if (indexOfNextClosingBracket > -1) {
                    var name = currentContent.substring(i + shiftRight + 2, indexOfNextClosingBracket);
                    if (value.indexOf(name, i + 1) === i + 1) {
                        // we know the next set of characters is the name portion of a mention
                        if (currentContent[indexOfNextClosingBracket + 1] === "(") {
                            // We are at the start of the id portion of a mention
                            var indexOfFirstClosingBrace = indexOfNextClosingBracket + 1;
                            var indexOfNextClosingBrace = currentContent.indexOf(")", indexOfNextClosingBracket + 2);
                            if (indexOfNextClosingBrace > -1) {
                                var lengthOfId = indexOfNextClosingBrace - indexOfFirstClosingBrace + 1; // +1 to include both parenthesis
                                restrictedRanges.push([
                                    i + shiftRight + 1,
                                    indexOfNextClosingBrace, 
                                ]);
                                shiftRight += lengthOfId + 2; // +2 for the []
                            }
                        }
                    }
                }
            }
        }
        var shiftedPosition = position + shiftRight;
        isRestrictedPosition = restrictedRanges.some(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), start = _param[0], end = _param[1];
            return shiftedPosition >= start && shiftedPosition <= end;
        });
    }
    if (!isRestrictedPosition) {
        return (0,_textHelpers__WEBPACK_IMPORTED_MODULE_1__/* .insertAtPosition */ .j0)(currentContent, position + shiftRight, emoji);
    }
    return content || "";
};



/***/ }),

/***/ 14255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vo": function() { return /* binding */ MENTION_REGEX_GLOBAL; },
/* harmony export */   "YA": function() { return /* binding */ mentionIdRegex; },
/* harmony export */   "xA": function() { return /* binding */ MENTION_REGEX; },
/* harmony export */   "yI": function() { return /* binding */ escapeRegex; }
/* harmony export */ });
var MENTION_REGEX = /@\[([^[]+?)]\(([\w\d=]+)\)/;
var MENTION_REGEX_GLOBAL = new RegExp(MENTION_REGEX.source, "g");
var mentionIdRegex = function(id) {
    return new RegExp("@\\[[^\\[]+?]\\(".concat(id, "\\)"), "g");
};
var escapeRegex = function(input) {
    return input.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
};


/***/ }),

/***/ 97346:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"ActionModal_sr-only--mobile__VoUeq","sr-only":"ActionModal_sr-only__aoWhY","error-message":"ActionModal_error-message__9vTsi","form-inline-edit":"ActionModal_form-inline-edit__FeRPj","form-group":"ActionModal_form-group__fKluu","form-row":"ActionModal_form-row__4UEIy","form-inline":"ActionModal_form-inline__9bfuP","error":"ActionModal_error__fM28f","input-group-append":"ActionModal_input-group-append__XrswW","input-group-currency":"ActionModal_input-group-currency__dDAfA","form-control":"ActionModal_form-control__SNTHx","custom-select":"ActionModal_custom-select__rjYN_","is-invalid":"ActionModal_is-invalid__050SP","is-valid":"ActionModal_is-valid__1ScCd","input-group":"ActionModal_input-group__x6u6w","input-group-text":"ActionModal_input-group-text__DT06u","input-group-prepend":"ActionModal_input-group-prepend__MNhsM","valid-feedback":"ActionModal_valid-feedback__gSs0t","invalid-feedback":"ActionModal_invalid-feedback__rd7t8","form-text":"ActionModal_form-text__BhPxc","label":"ActionModal_label__PDsbu","custom-control":"ActionModal_custom-control__5FLge","custom-control-label":"ActionModal_custom-control-label__vK6wK","custom-control-label--empty":"ActionModal_custom-control-label--empty__Tq0cd","custom-control-input":"ActionModal_custom-control-input__ebI9R","action-modal":"ActionModal_action-modal__j4dyB","action-modal__body":"ActionModal_action-modal__body__2Zi01","action-modal__list":"ActionModal_action-modal__list__xtO9Q","action-modal__close-button":"ActionModal_action-modal__close-button__NTskS"};

/***/ }),

/***/ 11595:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"ActionModalItem_sr-only--mobile__uLQQL","sr-only":"ActionModalItem_sr-only__yehCj","error-message":"ActionModalItem_error-message__XtZKf","form-inline-edit":"ActionModalItem_form-inline-edit__EljuP","form-group":"ActionModalItem_form-group__qdvr2","form-row":"ActionModalItem_form-row__5ikbL","form-inline":"ActionModalItem_form-inline__e_EqG","error":"ActionModalItem_error__HO9aW","input-group-append":"ActionModalItem_input-group-append__AZ1xD","input-group-currency":"ActionModalItem_input-group-currency__hM7o_","form-control":"ActionModalItem_form-control__1DWlG","custom-select":"ActionModalItem_custom-select__FiSly","is-invalid":"ActionModalItem_is-invalid__Rhnfo","is-valid":"ActionModalItem_is-valid__Li_Aa","input-group":"ActionModalItem_input-group__v4MZl","input-group-text":"ActionModalItem_input-group-text__ITqPq","input-group-prepend":"ActionModalItem_input-group-prepend__SZN_I","valid-feedback":"ActionModalItem_valid-feedback__rMUIZ","invalid-feedback":"ActionModalItem_invalid-feedback__Vw68I","form-text":"ActionModalItem_form-text__ZBhMw","label":"ActionModalItem_label__b3Org","custom-control":"ActionModalItem_custom-control__Ac4yx","custom-control-label":"ActionModalItem_custom-control-label__jjvOX","custom-control-label--empty":"ActionModalItem_custom-control-label--empty__I2kst","custom-control-input":"ActionModalItem_custom-control-input__KJR43","action-modal-item":"ActionModalItem_action-modal-item__j98Hk","action-modal-item--danger":"ActionModalItem_action-modal-item--danger__Vhgm6","action-modal-item__button":"ActionModalItem_action-modal-item__button__m5BDm"};

/***/ }),

/***/ 12114:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Highlight_sr-only--mobile__kuna1","sr-only":"Highlight_sr-only__LYFK5","error-message":"Highlight_error-message__IDp9K","form-inline-edit":"Highlight_form-inline-edit__5CF1q","form-group":"Highlight_form-group__B6Mht","form-row":"Highlight_form-row__2eaE_","form-inline":"Highlight_form-inline__n0H4X","error":"Highlight_error__ScrUV","input-group-append":"Highlight_input-group-append__Lp9JC","input-group-currency":"Highlight_input-group-currency__w5sKE","form-control":"Highlight_form-control__HOTDd","custom-select":"Highlight_custom-select__xrCKR","is-invalid":"Highlight_is-invalid__QS_2G","is-valid":"Highlight_is-valid__rB_jg","input-group":"Highlight_input-group__4Gomq","input-group-text":"Highlight_input-group-text__dnQc9","input-group-prepend":"Highlight_input-group-prepend__ou11Y","valid-feedback":"Highlight_valid-feedback__mDBb7","invalid-feedback":"Highlight_invalid-feedback__B4qgC","form-text":"Highlight_form-text__lQ2PV","label":"Highlight_label__cZQaA","custom-control":"Highlight_custom-control__NggzV","custom-control-label":"Highlight_custom-control-label__3_r8k","custom-control-label--empty":"Highlight_custom-control-label--empty___xl1y","custom-control-input":"Highlight_custom-control-input__Km0ZF","mention__tooltip-inner":"Highlight_mention__tooltip-inner__rKRXY","mention__tooltip":"Highlight_mention__tooltip__y6VZe","user__avatar":"Highlight_user__avatar__RiI9A","mentions-highlight":"Highlight_mentions-highlight__I5j6p","current-user":"Highlight_current-user__Vzlf5","highlight":"Highlight_highlight__QgjJO"};

/***/ }),

/***/ 82845:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Post_sr-only--mobile__Bgh3o","sr-only":"Post_sr-only___SrZs","error-message":"Post_error-message__5EDUa","form-inline-edit":"Post_form-inline-edit__CVFJE","form-group":"Post_form-group__lBmop","form-row":"Post_form-row__1iSnw","form-inline":"Post_form-inline__ZVJB6","error":"Post_error__FQG9f","input-group-append":"Post_input-group-append__9lZ29","input-group-currency":"Post_input-group-currency__LgiL5","form-control":"Post_form-control__O3wRG","custom-select":"Post_custom-select__8bhD0","is-invalid":"Post_is-invalid__xlzAU","is-valid":"Post_is-valid__riwcb","input-group":"Post_input-group__9cDC2","input-group-text":"Post_input-group-text__O_ZkL","input-group-prepend":"Post_input-group-prepend__4zUuS","valid-feedback":"Post_valid-feedback__QHJa8","invalid-feedback":"Post_invalid-feedback__UaNLV","form-text":"Post_form-text__DyzwV","label":"Post_label__HZGYf","custom-control":"Post_custom-control__alONa","custom-control-label":"Post_custom-control-label__0e0e6","custom-control-label--empty":"Post_custom-control-label--empty__oOx1N","custom-control-input":"Post_custom-control-input___IIPj","post":"Post_post__HGUDA","post__container":"Post_post__container__77Q5S","post__container--full":"Post_post__container--full__zZ2ty","post__content":"Post_post__content__w67vW","post__content--attachment":"Post_post__content--attachment__KTCv4","video__container":"Post_video__container__z0wmx","post__detail":"Post_post__detail__wDEJ6","is-spaces-enabled":"Post_is-spaces-enabled__JIXt_","post__body":"Post_post__body__9OX6f","post__info":"Post_post__info__6rFUh","post__footer":"Post_post__footer__8tZj8","total-comments":"Post_total-comments__LVP_T","total-likes":"Post_total-likes__SKn2O","post__detail-action":"Post_post__detail-action__ds9nx","post__detail-action__icon":"Post_post__detail-action__icon__Lvw2x","post__detail-header":"Post_post__detail-header__g_moM","is-following":"Post_is-following__Qb3xN","icon":"Post_icon__aqLzb","post__detail-actions":"Post_post__detail-actions__S3Wgd","post__detail-actions__follow-tag":"Post_post__detail-actions__follow-tag__NTk8l","post__detail-actions__pin-icon":"Post_post__detail-actions__pin-icon___SRsf","post__title":"Post_post__title__KucH4","post__content--button":"Post_post__content--button__KevQB","post__content__text--clamped":"Post_post__content__text--clamped__GTQxo","post__separator":"Post_post__separator__D8ocC","comment-container":"Post_comment-container__XPWOZ","comment-input__wrapper":"Post_comment-input__wrapper__jHtfH","comment-input__avatar":"Post_comment-input__avatar__JcTZb","comment-input__avatar-container":"Post_comment-input__avatar-container__YoIAz","post-comment":"Post_post-comment__PIA0b","post-comment__modal":"Post_post-comment__modal__5nDbj","post-comment__modal-header-text--dark":"Post_post-comment__modal-header-text--dark__uTOMf","post-comment__modal-header-text--light":"Post_post-comment__modal-header-text--light__lqBQ6","has-value":"Post_has-value__02KCr"};

/***/ }),

/***/ 56571:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"PostSpaceBadge_sr-only--mobile__SC8zR","sr-only":"PostSpaceBadge_sr-only__MZtR0","error-message":"PostSpaceBadge_error-message__5YxlV","form-inline-edit":"PostSpaceBadge_form-inline-edit__djERb","form-group":"PostSpaceBadge_form-group__ixZFP","form-row":"PostSpaceBadge_form-row__DBf1Q","form-inline":"PostSpaceBadge_form-inline__gI_wk","error":"PostSpaceBadge_error__8cUVY","input-group-append":"PostSpaceBadge_input-group-append__YKyC3","input-group-currency":"PostSpaceBadge_input-group-currency__3xBvO","form-control":"PostSpaceBadge_form-control__tsLdh","custom-select":"PostSpaceBadge_custom-select__nzk1_","is-invalid":"PostSpaceBadge_is-invalid__iT9VX","is-valid":"PostSpaceBadge_is-valid__HWTnu","input-group":"PostSpaceBadge_input-group__ddnTU","input-group-text":"PostSpaceBadge_input-group-text__YW0pv","input-group-prepend":"PostSpaceBadge_input-group-prepend__XwpZ4","valid-feedback":"PostSpaceBadge_valid-feedback__txvkp","invalid-feedback":"PostSpaceBadge_invalid-feedback__GE1dH","form-text":"PostSpaceBadge_form-text__DBjdD","label":"PostSpaceBadge_label__wTl4V","custom-control":"PostSpaceBadge_custom-control__a_TB_","custom-control-label":"PostSpaceBadge_custom-control-label__Knga_","custom-control-label--empty":"PostSpaceBadge_custom-control-label--empty__nJCEt","custom-control-input":"PostSpaceBadge_custom-control-input__cFAx9","badge":"PostSpaceBadge_badge__KDC9T","badge__icon":"PostSpaceBadge_badge__icon__i6qdy"};

/***/ }),

/***/ 70589:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"PostActions_sr-only--mobile__htvi_","sr-only":"PostActions_sr-only__bTr9A","error-message":"PostActions_error-message__IcK9G","form-inline-edit":"PostActions_form-inline-edit__TuYaq","form-group":"PostActions_form-group__iWIAD","form-row":"PostActions_form-row__OfGD6","form-inline":"PostActions_form-inline__q4MPu","error":"PostActions_error__V1Zfq","input-group-append":"PostActions_input-group-append__06b78","input-group-currency":"PostActions_input-group-currency__IT18k","form-control":"PostActions_form-control__bXLjs","custom-select":"PostActions_custom-select__j2OwF","is-invalid":"PostActions_is-invalid__kZYgk","is-valid":"PostActions_is-valid__aLkul","input-group":"PostActions_input-group__PCPL6","input-group-text":"PostActions_input-group-text__stptd","input-group-prepend":"PostActions_input-group-prepend__5WRBH","valid-feedback":"PostActions_valid-feedback__p5Oba","invalid-feedback":"PostActions_invalid-feedback__T3QDR","form-text":"PostActions_form-text__r38Xd","label":"PostActions_label__YztH9","custom-control":"PostActions_custom-control__JgGmM","custom-control-label":"PostActions_custom-control-label__eca9M","custom-control-label--empty":"PostActions_custom-control-label--empty__hveGf","custom-control-input":"PostActions_custom-control-input__hbuW8","post-actions__button":"PostActions_post-actions__button__M9ZsV","post-actions__button-icon":"PostActions_post-actions__button-icon___z_AF"};

/***/ }),

/***/ 88968:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"UserDetail_sr-only--mobile__RNEa_","sr-only":"UserDetail_sr-only__a9Clh","error-message":"UserDetail_error-message__MXSsz","form-inline-edit":"UserDetail_form-inline-edit__shiXa","form-group":"UserDetail_form-group__5yr2g","form-row":"UserDetail_form-row__wWpUc","form-inline":"UserDetail_form-inline__EkDMg","error":"UserDetail_error__N_PkP","input-group-append":"UserDetail_input-group-append__E8kqW","input-group-currency":"UserDetail_input-group-currency__UbRIz","form-control":"UserDetail_form-control__Mr_Ft","custom-select":"UserDetail_custom-select__4cCCq","is-invalid":"UserDetail_is-invalid___7uwy","is-valid":"UserDetail_is-valid__cKWwV","input-group":"UserDetail_input-group__M9f6B","input-group-text":"UserDetail_input-group-text__otj0Y","input-group-prepend":"UserDetail_input-group-prepend__XZ4n4","valid-feedback":"UserDetail_valid-feedback__R_6BI","invalid-feedback":"UserDetail_invalid-feedback__5Vc_E","form-text":"UserDetail_form-text__geZeT","label":"UserDetail_label___G1Ju","custom-control":"UserDetail_custom-control__n_Vge","custom-control-label":"UserDetail_custom-control-label__TnrlE","custom-control-label--empty":"UserDetail_custom-control-label--empty__vAl6D","custom-control-input":"UserDetail_custom-control-input__irLEV","user-detail":"UserDetail_user-detail__aXat9","user-detail__wrapper":"UserDetail_user-detail__wrapper__03EpO","user-detail__edit":"UserDetail_user-detail__edit__tSGi6","user-detail__avatar":"UserDetail_user-detail__avatar__iCGcJ","user-detail__reply":"UserDetail_user-detail__reply__ysW2L","user-detail__name":"UserDetail_user-detail__name__LQwQn","user-detail__label":"UserDetail_user-detail__label__YU0MU","user-detail__role":"UserDetail_user-detail__role__xCJqU","user-detail__edited":"UserDetail_user-detail__edited__6AD8t","user-detail__total-replies":"UserDetail_user-detail__total-replies__QweA_","user-detail__following":"UserDetail_user-detail__following__H9S42","user-detail__name-moderator":"UserDetail_user-detail__name-moderator__rOb09","user-detail__moderator-badge":"UserDetail_user-detail__moderator-badge__PKWUc"};

/***/ }),

/***/ 4861:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"InlineActions_sr-only--mobile__oAwF5","sr-only":"InlineActions_sr-only__pOnr3","error-message":"InlineActions_error-message__FCI2b","form-inline-edit":"InlineActions_form-inline-edit__sDmoj","form-group":"InlineActions_form-group__uYVYg","form-row":"InlineActions_form-row__B3j5b","form-inline":"InlineActions_form-inline__wEeG9","error":"InlineActions_error__8fdpP","input-group-append":"InlineActions_input-group-append__miXKL","input-group-currency":"InlineActions_input-group-currency__PTy2k","form-control":"InlineActions_form-control__TuXpQ","custom-select":"InlineActions_custom-select__JWlBH","is-invalid":"InlineActions_is-invalid__wpgZp","is-valid":"InlineActions_is-valid__YvscZ","input-group":"InlineActions_input-group__CHzyl","input-group-text":"InlineActions_input-group-text__7CP_t","input-group-prepend":"InlineActions_input-group-prepend__cyvcj","valid-feedback":"InlineActions_valid-feedback__mBS5t","invalid-feedback":"InlineActions_invalid-feedback__aio11","form-text":"InlineActions_form-text__X06uk","label":"InlineActions_label__IpW43","custom-control":"InlineActions_custom-control__DqzHZ","custom-control-label":"InlineActions_custom-control-label__XleFn","custom-control-label--empty":"InlineActions_custom-control-label--empty__CNKNX","custom-control-input":"InlineActions_custom-control-input__GSEIz","container":"InlineActions_container__teSd_","container-left":"InlineActions_container-left__ycFrv","container-right":"InlineActions_container-right__G3i1N","action-button":"InlineActions_action-button__Zehrs","active":"InlineActions_active__E_H8Y","inline-actions__more-actions--button":"InlineActions_inline-actions__more-actions--button__H3zv6","pressed":"InlineActions_pressed__y2d5I","focused":"InlineActions_focused__fhHEG","inline-actions__item":"InlineActions_inline-actions__item__rLkfX","dropdown-menu__item":"InlineActions_dropdown-menu__item__p2BkT","inline-actions__separator":"InlineActions_inline-actions__separator__Qtzx_","inline-actions--toggle":"InlineActions_inline-actions--toggle__V8XAh","compact-mode":"InlineActions_compact-mode__F0KFV","inline-actions--active-toggle":"InlineActions_inline-actions--active-toggle__8dhsv"};

/***/ }),

/***/ 35330:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Modal_sr-only--mobile__eokwy","sr-only":"Modal_sr-only__IrpXt","error-message":"Modal_error-message__AStAm","form-inline-edit":"Modal_form-inline-edit__JE0cN","form-group":"Modal_form-group__iOldY","form-row":"Modal_form-row__XwycR","form-inline":"Modal_form-inline__s43Nr","error":"Modal_error__qqU2V","input-group-append":"Modal_input-group-append__W_jHM","input-group-currency":"Modal_input-group-currency__zzeYh","form-control":"Modal_form-control__VewJS","custom-select":"Modal_custom-select__zy42f","is-invalid":"Modal_is-invalid__TUGK9","is-valid":"Modal_is-valid__oQGae","input-group":"Modal_input-group__SfEk9","input-group-text":"Modal_input-group-text__0VK1q","input-group-prepend":"Modal_input-group-prepend__I_Uqj","valid-feedback":"Modal_valid-feedback__ECE1m","invalid-feedback":"Modal_invalid-feedback__ZZl5M","form-text":"Modal_form-text__j5TKR","label":"Modal_label__g42Cg","custom-control":"Modal_custom-control__o05rR","custom-control-label":"Modal_custom-control-label__LKEHv","custom-control-label--empty":"Modal_custom-control-label--empty__O_oPD","custom-control-input":"Modal_custom-control-input__26GdC","modal":"Modal_modal__KpzhD","modal__header":"Modal_modal__header__jeavZ","has-title":"Modal_has-title__KooDk","modal__header__close-button":"Modal_modal__header__close-button__ZPkNo","modal__body":"Modal_modal__body__yRfMT","no-padding":"Modal_no-padding__uabdQ","modal__footer":"Modal_modal__footer__xc3ck","overlay":"Modal_overlay__RA50U"};

/***/ })

}]);